module.exports = __webpack_public_path__ + "media/images/iconBell__errorRed--dark-2fb4a4096e92b190a5c38832e743598f.png";